import * as domHelpers from "../../scripts/utils/domHelpers";

class AddGiftVoucher {
    constructor() {
        this.wrapHeader();
        this.handleRadioFields();
    }

    wrapHeader() {
        const headerElements = document.querySelectorAll(
            ".AddGiftVoucherBlurb",
        );

        domHelpers.wrapAll(headerElements, {
            element: "div",
            className: ["spektrix-page-header"],
        });
    }

    handleRadioFields() {
        const radioInputs = document.querySelectorAll(`.SendTo [type="radio"]`);

        radioInputs.forEach((input) => {
            const elements = [input];

            if (input.nextElementSibling?.matches("label")) {
                elements.push(input.nextElementSibling);
            }

            domHelpers.wrapAll(elements, {
                element: "div",
                className: [
                    "form-field--checkbox-radio",
                    "spx-field-container",
                ],
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pageSelector = document.querySelector(".SpektrixPage.AddGiftVoucher");

    if (pageSelector) {
        new AddGiftVoucher();
    }
});
